import React, { useState, useEffect } from "react";
import { useGlobalContext } from "store/contexts/globalContext";
import ImageModal from "./ImageModal";
import AudioModal from "./AudioModal";

export default ({
  attachment = null,
  type,
  typeId,
  children,
  teamPage = true,
  mediaClassName,
}) => {
  const [showPreviewDialog, setShowPreviewDialog] = useState(false);
  const [style, setStyle] = useState({ cursor: "pointer" });
  const rightSidebarExist = document.getElementById("right-sidebar");
  const { microsoftConfigureTab } = useGlobalContext();

  useEffect(() => {
    if (!attachment) {
      setStyle({ cursor: "inherit", pointerEvents: "none" });
      return;
    }
    setStyle({ cursor: "pointer", pointerEvents: "all" });
  }, [attachment]);

  const showPreviewDailog = () => {
    if (teamPage && rightSidebarExist) {
      rightSidebarExist.style.zIndex = "-1";
    }
    if (!microsoftConfigureTab) {
      document.getElementById("footer").style.zIndex = "-1";
    }
    document.getElementById("header").style.zIndex = "-1";
    setShowPreviewDialog(true);
  };

  const closePreviewDailog = () => {
    if (teamPage && rightSidebarExist) {
      rightSidebarExist.style.zIndex = "1";
    }
    if (!microsoftConfigureTab) {
      document.getElementById("footer").style.zIndex = "1";
    }
    document.getElementById("header").style.zIndex = "1";
    setShowPreviewDialog(false);
  };

  const preventDefaultOnClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
  };

  return (
    <>
      <div onClick={showPreviewDailog} style={style} className={mediaClassName}>
        {children}
      </div>
      {showPreviewDialog && (
        <>
          {(type === "image" || type === "photo"  || typeId === 2) && (
            <ImageModal
              closePreviewDailog={closePreviewDailog}
              attachment={attachment}
              type={type}
              preventDefault={preventDefaultOnClick}
            />
          )}
          {(type === "audio" || typeId === 4) && (
            <AudioModal
              closePreviewDailog={closePreviewDailog}
              attachment={attachment}
              type={type}
              preventDefault={preventDefaultOnClick}
            />
          )}
        </>
      )
      }
    </>
  );
};
